import 'choices.js/public/assets/styles/choices.css'
import { Controller } from "@hotwired/stimulus"
import Choices from 'choices.js'

export default class extends Controller {
  static targets = ["input"]
  declare inputTarget: HTMLInputElement
  declare choices: Choices

  connect() {
    this.choices = new Choices(this.inputTarget, {
      removeItemButton: true,
      duplicateItemsAllowed: false,
      paste: true,
      searchEnabled: true,
      placeholder: true,
      loadingText: 'Lade...',
      noResultsText: 'Keine Ergebnisse gefunden',
      noChoicesText: 'Keine Auswahlmöglichkeiten',
      itemSelectText: 'Klicken um auszuwählen',
      addItemText: (value: string) => `Drücken Sie Enter um <b>"${value}"</b> hinzuzufügen`,
      maxItemText: (maxItemCount: number) => `Nur ${maxItemCount} Werte können ausgewählt werden`,
    })
    this.element['choices'] = this.choices
  }

  disconnect() {
    delete this.element['choices']
    this.choices?.destroy()
  }
}
